import { forwardRef, useEffect } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
  CircularProgress,
  Switch,
  FormControlLabel,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  SettingsActions,
} from "../../../app/slices/settingsSlice";
import { Controller, useForm } from "react-hook-form";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SettingsForm = () => {
  const dispatch = useDispatch();

  const _Setting = useSelector((state) => state.settings.setting);
  const _SearchBody = useSelector((state) => state.settings.searchBody);
  const loading = useSelector((state) => state.settings.settings.loading);

  const {
    formState: { errors },
    control,
    handleSubmit,
  } = useForm({
    defaultValues: _Setting.form,
  });

  const onSubmit = (data) => {
    dispatch(
      SettingsActions.update(
        data.id,
        {
          value: data.value,
          note: data.note,
        },
        _SearchBody
      )
    );
  };

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasError = (fieldName) => {
    return !!errors[fieldName];
  };

  const handleDialog = () => {
    dispatch(setDialog());
  };
  return (
    <Dialog
      open={_Setting.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      onClose={() => {
        handleDialog();
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          {"تعديل"}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Controller
                name="value"
                control={control}
                rules={{
                  required: { value: true, message: "الحقل مطلوب" },
                  validate: (value) => {
                    if (_Setting.form.key === "withdraw_by_rep_enabled") {
                      const numValue = Number(value);
                      if (numValue !== 0 && numValue !== 1) {
                        return "القيمة يجب أن تكون 0 أو 1 فقط";
                      }
                    }
                    return true;
                  },
                }}
                render={({ field }) => {
                  const switchKeys = [
                    "withdraw_by_rep_enabled",
                    "is_default_payment_fees",
                    "active_e_payment",
                  ];
                  if (switchKeys.includes(_Setting.form.key)) {
                    return (
                      <FormControlLabel
                        control={
                          <Switch
                            checked={Number(field.value) === 1}
                            onChange={(e) =>
                              field.onChange(e.target.checked ? 1 : 0)
                            }
                          />
                        }
                        label={Number(field.value) === 1 ? "مفعل" : "غير مفعل"}
                      />
                    );
                  }
                  return (
                    <TextField
                      type="number"
                      size="small"
                      label="القيمة"
                      fullWidth
                      error={hasError("value")}
                      helperText={errors.value ? errors.value.message : ""}
                      inputProps={
                        _Setting.form.key === "withdraw_by_rep_enabled"
                          ? { min: 0, max: 1, step: 1 }
                          : {}
                      }
                      {...field}
                    />
                  );
                }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Controller
                name="note"
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    label="الملاحظة"
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "حفظ"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsForm;
